const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

export default {
  routes: [
    {
      path: '/agmt/index',
      name: 'agmt_index',
      component: Index
    },
    {
      path: '/agmt/personal',
      name: 'agmt_personal',
      component: Personal
    }
  ]
}
